export default "__VITE_ASSET__CtEJkeSA__"